import React from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { hydrate } from 'react-dom';
import { loadableReady } from '@loadable/component';

import 'app/client/utils/log';

import App from 'app/shared/pages/App';
import MultiAnalyticsModule from 'app/shared/utils/analytics';
import configureStore from 'app/shared/flux/configureStore';
import setupAnalytics from 'app/client/utils/setupAnalytics';
import setupRouting from 'app/client/utils/setupRouting';
import initDatadog from 'app/client/utils/datadog';
import { initTracer } from '@zg-rentals/trace-browser';

initTracer();

const history = createBrowserHistory();

// eslint-disable-next-line no-underscore-dangle
const initialState = window.__INITIAL_STATE__;

const store = configureStore(initialState, history);
const { isProd } = store.getState().app;
window.store = store;
window.browserHistory = history;

// Initialize analytics on client
new MultiAnalyticsModule().init({ isProd }).getMa();
initDatadog({ isProd });

setupAnalytics(store.dispatch);
setupRouting(store.dispatch);

const AppRoot = (
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <App />
        </ConnectedRouter>
    </Provider>
);

loadableReady(() => {
    hydrate(AppRoot, document.getElementById('app-root'));
});
